module.exports = __webpack_public_path__ + "img/仁天环保.2bf3f755.jpg";